import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

// import '../../component/scss/grade-table.scss';
import './grade-table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moUser from '@store/user';
import moIndex, { toggleTip } from '../../store/index';
import { exportExcelFile } from '@/tool';
import { toJS } from 'mobx';

interface IProps {
  tableHead: any[],
  tableArr: any[],
}
interface IState {}

const GradeTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { tableHead, tableArr } = props;
  const { isLogin } = moUser;
  const { isMock } = moIndex;

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const head:any = [
      ['一级职能', '二级职能', '三级职能', '所有公司的薪酬变化','','','','','相同公司相同职位的薪酬变化','','',''],
      ['', '', '', '公司数','公司数变化率','样本数','样本数变化率','涨薪率','公司数','样本数','样本数变化率','涨薪率'],
    ];
    const content :any = [];
    tableArr.forEach((item:any) => {
      content.push(item.arr);
    });
    const list:any = [...head, ...content];
    const merge = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },
      { s: { r: 0, c: 3 }, e: { r: 0, c: 7} },
      { s: { r: 0, c: 8 }, e: { r: 0, c: 13 } },
    ];
    exportExcelFile(list, merge, '细分职能涨薪率');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className={[
      "table-60655",
      !isMock ? '' : 'mock-100',
    ].join(' ')}>
    <section onClick={exporttable} className='export-table' style={{marginTop:'0px',marginBottom:'10px'}}>导出excel</section>
      <section className="content-101">
        {tableHead.map((item: any, index: number) => (
          <section key={index} className="row-101">
            <strong>{item.title}</strong>
            {item.child ? (
              <p className="line-101">
                {item.child?.map((child: any, idx: number) => (
                  <b key={idx}>{child}</b>
                ))}
              </p>
            ) : null}
          </section>
        ))}
      </section>
      <section className="content-103">
        {tableArr.map((item: any, index: number) => (
          <section key={index} className="row-103">
            {/* <span className="span-11">{item.category_lv1}</span>
            <span className="span-11">{item.category_lv2}</span>
            <span className="span-11">{item.category_lv3}</span> */}
            <p className="line-11">
              {item.arr?.map((child: any, idx: number) => (
                <span key={idx}
                  className={[
                    "span-13",
                    idx === 0 ? 'span-0013' : '',
                    idx === 1 ? 'span-0013' : '',
                    idx === 2 ? 'span-0013' : '',
                  ].join(' ')}>{child}
                </span>
              ))}
            </p>
          </section>
        ))}
      </section>
    </section>
  );
};

export default observer(GradeTable);
